export default {
    api: 'https://api.ruurd.dev',
    // api: 'http://localhost:3000',
}